import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { faTrashAlt, faPencilAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { PrescriptionTemplate } from '../prescription-template';
import { PrescriptionTemplateService } from '../../service/prescription-template.service';

declare var jQuery: any;

@Component({
  selector: 'mc-prescription-template-list',
  templateUrl: './prescription-template-list.component.html',
  styleUrls: ['./prescription-template-list.component.scss']
})
export class PrescriptionTemplateListComponent {

  trashAlt = faTrashAlt;
  pencilAlt = faPencilAlt;
  plusCircle = faPlusCircle;

  @ViewChild('createNewModal', { static: true }) private createNewModal: ElementRef;
  @Input() public templates: PrescriptionTemplate[];
  @Input() public crudMode: boolean = true;
  @Output() selected: EventEmitter<PrescriptionTemplate> = new EventEmitter<PrescriptionTemplate>();
  public templateToDelete: PrescriptionTemplate = new PrescriptionTemplate();

  constructor(
    private ptService: PrescriptionTemplateService,
    private notifService: ToastrService
  ) { }

  select(template: PrescriptionTemplate): void {
    this.selected.emit(template);
  }

  confirmDelete(template: PrescriptionTemplate): void {
    this.templateToDelete = template;
    jQuery(this.createNewModal.nativeElement).modal('show');
  }

  deletePrescriptionTemplate(): void {
    const id = this.templateToDelete.id;
    this.ptService.deletePrescriptionTemplate(id).subscribe(
      success => {
        const index = this.templates.findIndex(el => el.id == id);
        this.templates.splice(index, 1);
        this.notifService.success('Receita excluida');
      },
      error => this.notifService.error(error)
    );
  }
}
